const SOURCE_SCHEME_PATTERN = /^([a-z][a-z\d+.-]*):\/\//i;

const trimValue = (value) => (value ?? "").toString().trim();

export const parseCameraSourceUrl = (type, url, defaultOnvifPath) => {
  const sourceUrl = trimValue(url);

  if (type !== "onvif" || !/^onvif:\/\//i.test(sourceUrl)) {
    return { url: sourceUrl, path: defaultOnvifPath };
  }

  const withoutScheme = sourceUrl.replace(/^onvif:\/\//i, "");

  // Keep malformed nested schemes visible so validation can ask the user to fix them.
  if (SOURCE_SCHEME_PATTERN.test(withoutScheme)) {
    return { url: withoutScheme, path: defaultOnvifPath };
  }

  const slashIndex = withoutScheme.indexOf("/");
  if (slashIndex === -1) {
    return { url: withoutScheme, path: defaultOnvifPath };
  }

  return {
    url: withoutScheme.slice(0, slashIndex),
    path: `/${withoutScheme.slice(slashIndex + 1).replace(/^\/+/, "")}`,
  };
};

export const getCameraSourceUrlError = (type, url) => {
  if (type !== "rtsp" && type !== "onvif") return "";

  const sourceUrl = trimValue(url);
  if (!sourceUrl) return "La URL de la cámara es obligatoria.";
  if (/\s/.test(sourceUrl)) return "La URL de la cámara no puede contener espacios.";

  const scheme = sourceUrl.match(SOURCE_SCHEME_PATTERN)?.[1]?.toLowerCase();

  if (type === "rtsp") {
    const withoutScheme = sourceUrl.replace(/^rtsp:\/\//i, "");
    if (scheme !== "rtsp" || !withoutScheme || SOURCE_SCHEME_PATTERN.test(withoutScheme)) {
      return "La URL debe comenzar con rtsp:// y corresponder al tipo RTSP.";
    }
    return "";
  }

  const withoutScheme = sourceUrl.replace(/^onvif:\/\//i, "");
  if (
    (scheme && scheme !== "onvif") ||
    !withoutScheme ||
    SOURCE_SCHEME_PATTERN.test(withoutScheme) ||
    withoutScheme.includes("/")
  ) {
    return "La URL debe contener sólo el host y corresponder al tipo ONVIF.";
  }

  return "";
};

export const buildCameraSourceUrl = (type, url, onvifPath) => {
  const error = getCameraSourceUrlError(type, url);
  if (error) throw new Error(error);

  const sourceUrl = trimValue(url);
  if (type !== "onvif") return sourceUrl;

  const host = sourceUrl.replace(/^onvif:\/\//i, "").replace(/\/+$/, "");
  const path = trimValue(onvifPath || "/onvif/device_service").replace(/^\/+/, "");

  return `onvif://${host}/${path}`;
};
